import React from 'react';
import { ConfirmModal } from '../../commons/components/ConfirmModal';
import useApi from '../../api/backendApiContext';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { openUrlInNewTab } from '../../util/window-utils';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';

export const AddPaymentMethodModal = ({ onClose }: { onClose?: () => void }) => {
  const { billingApi } = useApi();
  useAnalyticsPage(Page.ADD_PAYMENT_METHOD_FOR_AUTOMATIC_PAYMENT);

  const handleAddPaymentMethod = async () => {
    const billingPortalSession = await billingApi.createBillingPortalSession();
    openUrlInNewTab(
      billingPortalSession.url,
      {
        analyticsEvent: AnalyticsEvent.BILLING_CARD_ADD_NEW_FROM_AUTO_PAYMENT,
      },
      '/payment-methods'
    );
  };

  return (
    <ConfirmModal
      title="Add payment method"
      message="To allow Growegy to automatically charge your invoices on their due date, please add a payment method."
      ariaHideApp={false}
      onClose={onClose}
      footer={{
        type: 'show',
        applyButton: {
          label: 'Add payment method',
          onClick: handleAddPaymentMethod,
        },
        cancelButton: {
          label: 'Cancel',
          onClick: () => {},
        },
      }}
    />
  );
};
